import { render, staticRenderFns } from "./RenGongChaoShiData.vue?vue&type=template&id=60132629&scoped=true&"
import script from "./RenGongChaoShiData.vue?vue&type=script&lang=js&"
export * from "./RenGongChaoShiData.vue?vue&type=script&lang=js&"
import style0 from "./RenGongChaoShiData.vue?vue&type=style&index=0&id=60132629&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60132629",
  null
  
)

export default component.exports